export const buttonTypographyClasses = [
    "font-button-text",
    "font-weight-interactive-button",
    "text-mobile-button-medium",
    "sm-md:text-desktop-button-medium",
    "leading-[calc(1px+var(--leading-mobile-button-medium))]",
    "sm-md:leading-[calc(1px+var(--leading-desktop-button-medium))]",
    "tracking-button",
    "text-case-button",
];
